import { DashboardPageHeader } from './DashboardPageHeader'
import { IconAdjustmentsHorizontal, IconDots, IconLayout, IconLayoutGrid, IconList, IconPencil, IconPlus, IconSearch } from '@tabler/icons-react'
import { useI18n } from '../lib/i18n'
import { translate } from '../lib/i18n'

export function SkeletonRow() {
  const { t } = useI18n()
  return (
    <article className="dash-project-row dash-row-skeleton dash-granular-loading" aria-hidden="true">
      <div className="dash-project-row-main">
        <span className="dash-project-row-thumb sk" />
        <span className="dash-project-row-copy dash-row-skeleton-lines">
          <span className="sk sk-line sk-line-title" />
          <span className="sk sk-line sk-line-sub" />
        </span>
      </div>
      <div className="dash-project-row-actions">
        <button className="dash-primary-btn dash-project-row-action" type="button" tabIndex={-1} disabled>
          <IconLayout size={14} /> <span className="dash-project-row-action-label">{t('skeleton.openEditor')}</span>
        </button>
        <button className="project-menu-btn" type="button" tabIndex={-1} disabled>
          <IconDots size={15} />
        </button>
      </div>
    </article>
  )
}

/* These loaders mount the same shells, controls and spacing as the final UI.
   Only values coming from the API (image, name, date and counts) shimmer. */
export function SkeletonPageList({ count = 6, kind = 'pages' }: { count?: number; kind?: 'pages' | 'cms' }) {
  const { t } = useI18n()
  const pages = kind === 'pages'
  return (
    <section className={`${pages ? 'dash-projects-view dash-pages-view ' : ''}dash-skeleton-page-list dash-granular-loading`} aria-busy="true">
      <DashboardPageHeader
        title={pages ? t('pages.title') : t('section.cms')}
        subtitle={pages
          ? translate('pages.subtitle')
          : t('cms.subtitle')}
        actions={!pages ? (
          <button className="dash-primary-btn" type="button" tabIndex={-1} disabled><IconPencil size={14} /> {t('skeleton.openInEditor')}</button>
        ) : null}
      />
      {pages ? (
        <header className="dash-toolbar" aria-hidden="true">
          <div className="dash-toolbar-search">
            <button type="button" className="dash-toolbar-search-icon" tabIndex={-1} disabled><IconSearch size={16} /></button>
            <input placeholder={t('skeleton.searchPage')} tabIndex={-1} disabled />
          </div>
          <div className="dash-toolbar-controls">
            <button className="dash-filter-trigger" type="button" tabIndex={-1} disabled><IconAdjustmentsHorizontal size={15} /></button>
            <div className="dash-view-toggle">
              <button className="active" type="button" tabIndex={-1} disabled><IconLayoutGrid size={15} /></button>
              <button type="button" tabIndex={-1} disabled><IconList size={15} /></button>
            </div>
            <button className="dash-primary-btn dash-toolbar-create" type="button" tabIndex={-1} disabled><IconPlus size={15} /> {t('skeleton.newPage')}</button>
          </div>
        </header>
      ) : null}
      <div className="dash-project-list">
        {Array.from({ length: count }).map((_, i) => <SkeletonRow key={i} />)}
      </div>
    </section>
  )
}

